import React, { useEffect,useState,useRef } from "react";
import { Context,Hooks,Util,Request } from "@xt/xtbase";
const {XtContext,XtAuth} = Context;
const {useTranslation} = Hooks;
const {Big,getUrl,showRate} = Util;
const {XtSocketPublic} = Request;
import styles from "./index.module.less";
import { useStore } from '@/models';
import { observer } from 'mobx-react-lite';
import {get_ticker24h,get_kline} from "@/api/v4/market";
import LineChart from "@/components/App/LineChart";

const MarketCard = (props) => {
  const t = useTranslation();
  const { fund, market } = useStore();
  const [appState] = React.useContext(XtContext);
  const {lang, theme, colorReverse} = appState;

const markets = ["btc_usdt", "trx_usdt", "bnb_usdt", "avax_usdt"];

  const [cardList,setCardList] = useState([]);
  const cardListRef = useRef(cardList);

  useEffect(()=>{
    const symbols = markets.join(",")
    get_ticker24h({
      params: {
        symbols
      }
    }).then((res)=>{
      const ary = [];
      let doc;
      markets.map((market) => {
        doc = res.find((obj) => obj.s === market) || { s: market };
        ary.push(doc);
      });
      console.log(ary);
      setCardList(ary);
      cardListRef.current = ary;
      initChartData();
      markets.forEach((s) => {
        XtSocketPublic.addChannel({ event: "kline@" + s + ",3m" }, handleWsKlineCallback);
      });
      return ()=>{
        markets.forEach((s) => {
          XtSocketPublic.removeChannel({ event: "kline@" + s + ",3m" });
        });
      }
    })
  },[]);
  const initChartData = ()=>{
    markets.forEach((s) => {
      get_kline({
        params: {
          symbol: s,
          interval: "3m",
          limit: 480,
        },
      }).then((data) => {
        var l = cardListRef.current.filter((card)=>{
          return true;
        });
        setCardList(cardListRef.current.filter((card)=>{
          if(card.s == s)
          {
            card.chartData = data;
          }
          return true;
        }))
      });
    });
  }
  const handleWsKlineCallback = (res)=>{
    setCardList(cardListRef.current.filter((item)=>{
      if(item.s == res.s)
      {
        if(!item.chartData)
          item.chartData = [];
        var list = [];
        var flag = true;
        item.chartData.forEach((data) => {
          if (data.t == res.t) {
            list.push(res);
            flag = false;
          }
          else list.push(data);
        });
        if (flag) list.unshift(res);
        item.chartData = list;
      }
      return true;
    }))
  }

  const getColorCls = (item) => {
    const cr = (market && market.tickers.find(obj=>obj.s==item.s) || item).cr;
    return cr > 0 ? styles["up-color"] : styles["down-color"];
  }
  const getPrice = (item) => {
    const {  marketConfig } = market;
    const symbol = item["s"];
    const c = (market && market.tickers.find(obj=>obj.s==item.s) || item).c;
    const price = c || 0;
    return Big(+price).toFixedCy(marketConfig && marketConfig[symbol] ? marketConfig[symbol].buyPoint : 2);
  }
  const getPriceAssist = (item) => {
    const c = (market && market.tickers.find(obj=>obj.s==item.s) || item).c;
    const result = fund.getCoinValue(c, item.s.split("_")[1].toLowerCase());
    return `${Big(result).toFixedCy()} ${fund.assist.name}`;
  }
  const getVol = (item) => {
    const q = (market && market.tickers.find(obj=>obj.s==item.s) || item).q;
    if (!q) return "--";

    const market = item.s;
    let volume = +q;

    if (lang === "zh-CN") {
      if (volume > 1e8) {
        volume = Big(volume / 1e8).toFixedMaxCy(4) + "亿";
      } else if (volume > 1e4) {
        volume = Big(volume / 1e4).toFixedMaxCy(2) + "万";
      } else {
        volume = Big(volume).toFixedCy();
      }
    } else {
      if (volume > 1e8) {
        volume = Big(volume / 1e6).toFixedMaxCy(4) + "M";
      } else if (volume > 1e4) {
        volume = Big(volume / 1e3).toFixedMaxCy(2) + "K";
      } else {
        volume = Big(volume).toFixedCy();
      }
    }

    return volume + " " + market.split("_")[0].toUpperCase();
  }
  const getRate = (item)=>{
    const cr = (market && market.tickers.find(obj=>obj.s==item.s) || item).cr;
    return showRate(cr * 100);
  }
  const fontClassGlobal = (rate) => {
    const ret = !isNaN(+rate) && +rate != 0 ? (+rate > 0 ? "up-color" : "down-color") : "down-color";
    if(colorReverse == "1")
    {
      return ret == "up-color" ? "down-color" : "up-color";
    }
    return ret;
  }
  return (
    <div className={styles["page-market__lite"]}>
      <div>
        {cardList.map((item,index)=>{
          return <div className={styles["page-market__lite--card"]} key={"market_card_"+index} onClick={()=>{
            window.location.href = getUrl("/futures/detail/"+item.s);
          }}>
            <div>
              <div className={styles["iCardHead"]}>
                <span>{item.s.split("_").map((item)=>{return fund.getCurrencyDisplayName(item.toLowerCase())}).join("/")}</span>
              </div>
              <div className={styles["iCardMid"]}>
                <span>
                  <b className={getColorCls(item)}>{getPrice(item)}</b>
                  <small>&nbsp;/&nbsp;{getPriceAssist(item)}</small>
                </span>
              </div>
              <div className={styles.iCardBtm}>
                <span>
                  <b className={getColorCls(item)}>{getRate(item)}</b>
                  <small>&nbsp;{t("trade.volume") + " " + getVol(item)}</small>
                </span>
              </div>
            </div>
            <LineChart itemKey={"market_chart_"+item.s} chartData={item.chartData} theme={fontClassGlobal(item.cr)} width={120} height={60}/>
          </div>
        })}
      </div>
    </div>
  );
}
export default observer(MarketCard);